module.exports = __webpack_public_path__ + "img/fusion360.d16ce8bd.png";